import ConfigurableUniformSvg from '@/components/uniforms/ConfigurableUniformSvg';
import ProfessionalAttireSvg from '@/components/uniforms/ProfessionalAttireSvg';
import ParamedicUniformSvg from '@/components/uniforms/ParamedicUniformSvg';

export default function UniformPreview({ body = '#6B7280', trim = '#374151', templateId = null, pocketPipingHex = null, garment = 'scrubs', fixedIllustration = null, showBadge = true, provider = 'nhs' }) {
  if (garment === 'no_uniform') {
    return <ProfessionalAttireSvg className="uniform-preview" title="Professional clothing" />;
  }
  if (fixedIllustration === 'paramedic') {
    return <ParamedicUniformSvg className="uniform-preview" title="Paramedic uniform" />;
  }
  const resolvedTemplateId = templateId || (garment === 'healthcare_tunic' ? 'healthcare-tunic-v1' : 'scrub-vneck-v1');
  return <ConfigurableUniformSvg templateId={resolvedTemplateId} body={body} trim={trim} pocketPipingHex={pocketPipingHex} showBadge={showBadge} provider={provider} className="uniform-preview" title="Uniform colour preview" />;
}
